import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { HOME_DEFAULTS } from "../lib/homeDefaults";

const DEFAULTS = HOME_DEFAULTS;

export default function SiteContentTab() {
  const [form, setForm] = useState(DEFAULTS);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/site-content").then(({ data }) => {
      setForm({ ...DEFAULTS, ...data });
    });
  }, []);

  const save = async () => {
    setLoading(true);
    try {
      await api.put("/admin/site-content", form);
      toast.success("Site content updated");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Save failed");
    } finally {
      setLoading(false);
    }
  };

  const upd = (k, v) => setForm({ ...form, [k]: v });

  const fields = [
    { k: "hero_tag", label: "Hero eyebrow (e.g. FW / 26 Collection)" },
    { k: "hero_headline", label: "Hero headline", multi: true },
    { k: "hero_subtext", label: "Hero subtext", multi: true },
    { k: "hero_image_url", label: "Hero image URL" },
    { k: "hero_caption", label: "Hero image caption" },
    { k: "story_heading", label: "Our Story heading", multi: true },
    { k: "story_p1", label: "Our Story paragraph 1", multi: true },
    { k: "story_p2", label: "Our Story paragraph 2", multi: true },
    { k: "story_p3", label: "Our Story paragraph 3", multi: true },
    { k: "story_image_url", label: "Our Story image URL" },
    { k: "founded_year", label: "Stat 1 value (e.g. 2011)" },
    { k: "stat_1_label", label: "Stat 1 label (e.g. Since)" },
    { k: "artisan_count", label: "Stat 2 value (e.g. 3)" },
    { k: "stat_2_label", label: "Stat 2 label (e.g. Generations)" },
    { k: "steps_count", label: "Stat 3 value (e.g. Agra)" },
    { k: "stat_3_label", label: "Stat 3 label (e.g. Home)" },
    { k: "marquee", label: "Marquee text (pipe | separated)", multi: true },
    { k: "_divider_cats", label: "── Category Tile Images ──", divider: true },
    { k: "cat_loafers_image", label: "Loafers — tile image URL" },
    { k: "cat_slip-ons_image", label: "Slip-Ons — tile image URL" },
    { k: "cat_chelsea_image", label: "Chelsea — tile image URL" },
    { k: "cat_derby_image", label: "Derby — tile image URL" },
    { k: "cat_monk_image", label: "Monk — tile image URL" },
    { k: "cat_heritage_image", label: "Heritage Comfort — tile image URL" },
    { k: "cat_wedding_image", label: "Wedding — tile image URL" },
  ];

  return (
    <div className="space-y-6 max-w-3xl">
      <p className="text-sm text-[#666]">
        Edit everything the customer sees on the homepage. Changes go live instantly.
      </p>
      {fields.map((f) => {
        if (f.divider) {
          return (
            <div key={f.k} className="pt-6 border-t border-[#e5e5e5]">
              <div className="label-eyebrow text-[#111]">{f.label.replace(/─/g, "").trim()}</div>
              <p className="text-xs text-[#666] mt-2">
                Paste any image URL (e.g. from your uploaded product images). Leave blank to show a minimal letter placeholder instead.
              </p>
            </div>
          );
        }
        return (
          <label key={f.k} className="block">
            <span className="label-eyebrow block mb-2">{f.label}</span>
            {f.multi ? (
              <textarea
                value={form[f.k] || ""}
                onChange={(e) => upd(f.k, e.target.value)}
                className="w-full border border-[#e5e5e5] p-3 focus:outline-none focus:border-[#111] bg-transparent min-h-[70px] text-sm"
                data-testid={`site-${f.k}`}
              />
            ) : (
              <input
                value={form[f.k] || ""}
                onChange={(e) => upd(f.k, e.target.value)}
                className="w-full border-b border-[#e5e5e5] py-2 focus:outline-none focus:border-[#111] bg-transparent text-sm"
                data-testid={`site-${f.k}`}
              />
            )}
          </label>
        );
      })}
      <button
        onClick={save}
        disabled={loading}
        className="bg-[#111] text-white px-8 py-3 text-sm font-medium hover:bg-[#333] disabled:opacity-60"
        data-testid="site-content-save"
      >
        {loading ? "Saving…" : "Save changes"}
      </button>
    </div>
  );
}
